import braze from '@services/braze';

function setAnonymousUser(email: string) {
  braze.setAnonymousUserAttributes(email);
}

let hasInitialized = false;
export default (() => {
  if (!hasInitialized) {
    hasInitialized = true;
    braze; // (default export is an iife that calls the necessary initialization methods required to use braze downstream)
  }
  return {
    setAnonymousUser,
  };
})();
